import { useState, useEffect } from "react";
import { useToast } from "./use-toast";
import { createDefaultNotification } from "../utils/notification";

export function useNotificationForm({
  notification,
  open,
  onSave,
  onOpenChange,
}) {
  const defaultNotification = createDefaultNotification();
  
  const [name, setName] = useState(notification?.name || "");
  const [url, setUrl] = useState(notification?.url || "");
  const [active, setActive] = useState(notification?.active || false);
  
  // Pop-up customization fields
  const [headline, setHeadline] = useState(notification?.popUp?.headline || defaultNotification.popUp.headline);
  const [subheadline, setSubheadline] = useState(notification?.popUp?.subheadline || defaultNotification.popUp.subheadline);
  const [primaryButtonText, setPrimaryButtonText] = useState(notification?.popUp?.primaryButtonText || defaultNotification.popUp.primaryButtonText);
  const [secondaryButtonText, setSecondaryButtonText] = useState(notification?.popUp?.secondaryButtonText || defaultNotification.popUp.secondaryButtonText);
  const [aiPrompt, setAiPrompt] = useState(notification?.popUp?.aiPrompt || defaultNotification.popUp.aiPrompt);
  
  const { toast } = useToast();

  // Reset form when notification changes or dialog opens
  useEffect(() => {
    if (open) {
      setName(notification?.name || "");
      setUrl(notification?.url || "");
      setActive(notification?.active || false);

      // Reset pop-up fields
      setHeadline(notification?.popUp?.headline || defaultNotification.popUp.headline);
      setSubheadline(notification?.popUp?.subheadline || defaultNotification.popUp.subheadline);
      setPrimaryButtonText(notification?.popUp?.primaryButtonText || defaultNotification.popUp.primaryButtonText);
      setSecondaryButtonText(notification?.popUp?.secondaryButtonText || defaultNotification.popUp.secondaryButtonText);
      setAiPrompt(notification?.popUp?.aiPrompt || defaultNotification.popUp.aiPrompt);
    }
  }, [notification, open]);

  const handleSave = () => {
    if (!name.trim()) {
      toast({
        title: "Error",
        description: "Name is required",
        variant: "destructive",
      });
      return;
    }

    if (!url.trim()) {
      toast({
        title: "Error",
        description: "URL is required",
        variant: "destructive",
      });
      return;
    }

    // Ensure URL has proper format
    let formattedUrl = url.trim();
    if (!formattedUrl.startsWith("http://") && !formattedUrl.startsWith("https://")) {
      formattedUrl = `https://${formattedUrl}`;
    }

    onSave({
      name,
      url: formattedUrl,
      active,
      popUp: {
        headline,
        subheadline,
        primaryButtonText,
        secondaryButtonText,
        aiPrompt,
      }
    });

    onOpenChange(false);
  };

  return {
    name,
    setName,
    url,
    setUrl,
    active,
    setActive,
    headline,
    setHeadline,
    subheadline,
    setSubheadline,
    primaryButtonText,
    setPrimaryButtonText,
    secondaryButtonText,
    setSecondaryButtonText,
    aiPrompt,
    setAiPrompt,
    handleSave
  };
}
